import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Menu, Icon } from 'antd'

const JobTitleArea = styled.div`
  background-color: transparent;
  padding-top: 2px;
  padding-left: 5px;
  padding-right: 5px;
`

class TitleArea extends Component {
  renderCurrentPageName = () => {
    const { currentPage } = this.props

    switch (currentPage) {
      case 'follow-ups':
        return 'Follow Ups'
      case 'payment-requests':
        return 'Payment Requests'
      case 'aias':
        return 'AIAs'
      case 'invoices':
        return 'Invoices'
      default:
        return ''
    }
  }

  render() {
    const { currentPage, handleClickMenu } = this.props
    return (
      <div className="dataHeader">
        <JobTitleArea>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">{this.renderCurrentPageName()}</li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 jobTitle">
              <h2>Dashboard</h2>
            </div>
          </div>
        </JobTitleArea>
        <Menu onClick={handleClickMenu} selectedKeys={[currentPage]} mode={'horizontal'}>
          <Menu.Item key="follow-ups">
            <Icon type="calculator" />Follow Ups
          </Menu.Item>
          <Menu.Item key="payment-requests">
            <Icon type="exception" />Payment Requests
          </Menu.Item>
          <Menu.Item key="aias">
            <Icon type="copy" />AIAs
          </Menu.Item>
          <Menu.Item key="invoices">
            <Icon type="notification" />Invoices
          </Menu.Item>
        </Menu>
      </div>
    )
  }
}

export default TitleArea



// WEBPACK FOOTER //
// ./src/components/dashboard/DataHeader.js